jPar.util = jPar.util || {};
deepMerge(true, jPar.util, {
	network: {
		hasValidSessionAndCsrfToken: function (loadedContent) {
			// isValidNetworkResponse
			// AJAX POST Requests mit CSRF-Token verhalten sich anders als GET Requests
			// Da greift dann erst die CSRF Prüfung und dann erst die 302 Session Prüfung
			/* eslint-disable-next-line no-prototype-builtins */ // TODO auf eslint hören und besser machen
			if (typeof loadedContent !== 'undefined' && loadedContent.hasOwnProperty('status')) {
				return loadedContent.status !== 403;
			} else {
				// BUG-5612 Ajax-Anfragen, die HTML zurückliefern darauf testen, ob die Login.-Seite kommt und ggf. weiterleiten.
				// BUG-13958 Ajax-Requests sometimes return welcomepage HTML
				return (
					typeof loadedContent !== 'string' ||
					(loadedContent.indexOf('<html') === -1 && loadedContent.indexOf('<body') === -1 && loadedContent.indexOf('loginForm') === -1)
				); // loginForm für die Tests
			}
		},

		reloadIfResponseInvalid: function (loadedContent, forceReload = false) {
			if (forceReload || this.hasValidSessionAndCsrfToken(loadedContent) === false) {
				if (document.querySelector('#errorModalboxSessionExpired.is-open') === null) {
					// nur einmal ausführen
					jPar.wdk.modalbox.show({ modalboxId: '#errorModalboxSessionExpired' });

					window.setTimeout(function () {
						const locationWithoutHash = document.URL.split('#')[0]; // Wenn ein Hash in der URL steht springt er nur zur sprungmarke anstatt zu navigieren
						location.replace(locationWithoutHash); // Damit beim nächsten login nicht der Ajax-Controller geladen wird.
					}, 500);
				}
			} else {
				return true;
			}
		},

		reloadForSessionExpired: function () {
			this.reloadIfResponseInvalid(null, true);
		},

		defaultErrorHandling: function (error) {
			if (error.type === 'technicalError') {
				if (error.message === 'browserTimeout') {
					document.querySelector('wdk-snackbar#timeoutNotification').show();
				} else if (error.message === 'sessionExpired') {
					jPar.util.network.reloadForSessionExpired();
				} else if (error.message === 'offline') {
					document.dispatchEvent(new CustomEvent('serviceworker:triggerOfflineAttention', { bubbles: true }));
				} else {
					if (document.querySelector('#errorDialog500') !== null) {
						document.querySelector('#errorDialog500').openModal();
					} else {
						jPar.wdk.modalbox.show({ modalboxId: 'errorModalbox500' }); //Deprecated
					}
				}
			} else {
				throw error;
			}
		},

		setGlobalAjaxTimeout: function () {
			const timeout = '15000'; // lets try with 15sek

			$j.ajaxSetup({
				timeout: timeout,
			});
		},
	},
});
